import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  padding: 0 3rem;
`;

const RowContainer = styled.div<{ divider?: boolean }>`
  display: flex;
  gap: 25rem;

  padding: 3rem 1rem;

  &:first-child {
    border-bottom: 1px solid ${pickColor('graySecondary')};
  }

  ${({ divider }) =>
    divider &&
    css`
      border-top: 1px solid ${pickColor('graySecondary')};
    `}
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  /* to align items */
  &:first-child {
    width: 9rem;
  }
`;

export { ContentContainer, RowContainer, ColumnContainer };
